import { addCollection } from "@iconify/react/offline";
import solarSubset from "./subset.json";

let loaded = false;

/** Офлайн-набор кита — поднабор solar, собранный `tools/build-icons.mjs`
 *  ровно по именам из кода. Раньше здесь лежал полный lucide (544 КБ на
 *  каждую загрузку ради 16 глифов), а solar ходил по сети: запрещённый набор
 *  был быстрее предпочтительного. */
export function loadCoreSet() {
  if (loaded) return;
  addCollection(solarSubset as any);
  loaded = true;
}

/** Есть ли глиф в офлайн-поднаборе. Префикс имени этого не решает: часть
 *  solar-имён рождается в рантайме и в поднабор не попала. */
export function isOffline(name: string): boolean {
  const [prefix, icon] = name.split(":");
  return prefix === solarSubset.prefix && Boolean((solarSubset.icons as Record<string, unknown>)[icon]);
}

/** On-demand: fetch icon from Iconify API, cache in localStorage */
export async function fetchIcon(name: string): Promise<boolean> {
  const cacheKey = `kit-icon:${name}`;
  const cached = typeof window !== "undefined" ? localStorage.getItem(cacheKey) : null;

  if (cached) {
    try {
      const { addIcon } = await import("@iconify/react/offline");
      addIcon(name, JSON.parse(cached));
      return true;
    } catch { return false; }
  }

  try {
    const [prefix, icon] = name.split(":");
    if (!prefix || !icon) return false;
    const res = await fetch(`https://api.iconify.design/${prefix}.json?icons=${icon}`);
    if (!res.ok) return false;
    const col = await res.json();
    let body = col.icons?.[icon];
    if (!body) {
      const alias = col.aliases?.[icon];
      if (alias?.parent) body = col.icons?.[alias.parent];
    }
    if (!body) return false;
    const iconData = { ...body, width: col.width || 24, height: col.height || 24 };
    const { addIcon } = await import("@iconify/react/offline");
    addIcon(name, iconData);
    if (typeof window !== "undefined") {
      localStorage.setItem(cacheKey, JSON.stringify(iconData));
    }
    return true;
  } catch { return false; }
}
